(function() {
    'use strict';

    angular.module('allegro').controller('AccountDetailController', AccountDetailController);

    AccountDetailController.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        'checkModelPermissionsSrvc',
        'notificationSrvc',
        'allegroAccountDataSrvc',
        'allegroConfigPermissionsConst',
        'allegroSellerPermissionsConst',
        'allegroSenderPermissionsConst',
        'allegroCodReceiverPermissionsConst',
        'allegroResponsibleProducerPermissionsConst',
        'allegroSafetyInformationPermissionsConst',
        'allegroOfferPermissionsConst',
        'allegroThreadPermissionsConst'
    ];

    function AccountDetailController(
        $scope,
        $state,
        $stateParams,
        checkModelPermissionsSrvc,
        notificationSrvc,
        allegroAccountDataSrvc,
        allegroConfigPermissionsConst,
        allegroSellerPermissionsConst,
        allegroSenderPermissionsConst,
        allegroCodReceiverPermissionsConst,
        allegroResponsibleProducerPermissionsConst,
        allegroSafetyInformationPermissionsConst,
        allegroOfferPermissionsConst,
        allegroThreadPermissionsConst
    ) {
        var self = this;

        // Methods
        self.getActiveTab = getActiveTab;
        self.getAccount = getAccount;
        self.isActiveTab = isActiveTab;
        self.hasMissingSettings = hasMissingSettings;
        self.hasAnySettingsPerm = hasAnySettingsPerm;
        self.hasOfferViewPerm = hasOfferViewPerm;
        self.hasThreadViewPerm = hasThreadViewPerm;

        // Data
        self.activeTab = self.getActiveTab();
        self.account = {};
        self.loading = false;

        activate();

        function activate() {
            self.getAccount($stateParams.pk);
        }

        function getAccount(accountPk) {
            self.loading = true;

            return allegroAccountDataSrvc.get({pk: accountPk})
                .$promise
                .then(function (response) {
                    self.account = response;
                    $scope.account = self.account;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function getActiveTab() {
            var stateName = $state.current.name;
            if (stateName.indexOf('overview') > -1) return 'overview';
            if (stateName.indexOf('settings') > -1) return 'settings';
            if (stateName.indexOf('offers') > -1) return 'offers';
            if (stateName.indexOf('threads') > -1) return 'threads';
            return 'overview';
        }

        function isActiveTab(tab) {
            return self.getActiveTab() === tab;
        }

        function hasMissingSettings(account) {
            var accountSettings = account.settings_fill_statuses;
            if (!accountSettings) {
                return false;
            }

            return Object.keys(accountSettings).some(function(key){
                return accountSettings[key] && !accountSettings[key].filled;
            });
        }

        function hasAnySettingsPerm() {
            return (
                !checkModelPermissionsSrvc.isDenied(allegroConfigPermissionsConst.view) ||
                !checkModelPermissionsSrvc.isDenied(allegroSellerPermissionsConst.view) ||
                !checkModelPermissionsSrvc.isDenied(allegroSenderPermissionsConst.view) ||
                !checkModelPermissionsSrvc.isDenied(allegroCodReceiverPermissionsConst.view) ||
                !checkModelPermissionsSrvc.isDenied(allegroResponsibleProducerPermissionsConst.view) ||
                !checkModelPermissionsSrvc.isDenied(allegroSafetyInformationPermissionsConst.view)
            );
        }

        function hasOfferViewPerm(){
            return !checkModelPermissionsSrvc.isDenied(allegroOfferPermissionsConst.view)
        }

        function hasThreadViewPerm(){
            return !checkModelPermissionsSrvc.isDenied(allegroThreadPermissionsConst.view)
        }
    }
})();
